(function () {
  var root = document.querySelector('[data-ms-catalog]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ms-product-card]'));
  var search = root.querySelector('[data-ms-catalog-search]');
  var searchClear = root.querySelector('[data-ms-search-clear]');
  var count = root.querySelector('[data-ms-result-count]');
  var empty = root.querySelector('[data-ms-filter-empty]');
  var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ms-category]'));
  var gender = root.querySelector('[data-ms-filter-gender]');
  var age = root.querySelector('[data-ms-filter-age]');
  var topic = root.querySelector('[data-ms-filter-topic]');
  var filtersClear = root.querySelector('[data-ms-filters-clear]');

  var puzzleTheme = root.querySelector('[data-pz-theme]');
  if (puzzleTheme) puzzleTheme.addEventListener('change', function () { state.category = puzzleTheme.value; applyFilters(); });
  var state = { query: '', category: 'all', gender: '', age: '', topic: '' };
  var initialAge = new URLSearchParams(window.location.search).get('age');
  if (age && Array.from(age.options).some(function (option) { return option.value === initialAge; })) {
    age.value = initialAge;
    state.age = initialAge;
  }

  var categoryTerms = {
    dinosaur: ['dinosaur'],
    ocean: ['océano', 'oceano', 'sirena', 'mar'],
    space: ['luna', 'espacio', 'estrella'],
    fantasy: ['fantas', 'dragón', 'dragon', 'princesa', 'tesoro', 'quijote', 'magia'],
    family: ['familia', 'mamá', 'mama', 'papá', 'papa', 'abuela', 'amistad']
  };

  function includesValue(csv, value) {
    if (!value) return true;
    return (csv || '').split(',').map(function (item) { return item.trim(); }).indexOf(value) !== -1;
  }

  function matchesCategory(keywords) {
    if (state.category === 'all') return true;
    return (categoryTerms[state.category] || []).some(function (term) {
      return keywords.indexOf(term) !== -1;
    });
  }

  function applyFilters() {
    var visible = 0;

    cards.forEach(function (card) {
      var title = (card.getAttribute('data-title') || '').toLowerCase();
      var keywords = (card.getAttribute('data-keywords') || title).toLowerCase();
      var cardGender = (card.getAttribute('data-gender') || 'unisex').toLowerCase();
      var cardAges = (card.getAttribute('data-ages') || '').toLowerCase();
      var cardTopics = (card.getAttribute('data-topics') || '').toLowerCase();

      var genderMatches = !state.gender || cardGender === state.gender || (state.gender !== 'unisex' && cardGender === 'unisex');
      var show = (!state.query || keywords.indexOf(state.query) !== -1) &&
        matchesCategory(keywords) &&
        genderMatches &&
        includesValue(cardAges, state.age) &&
        includesValue(cardTopics, state.topic);

      card.hidden = !show;
      if (show) visible += 1;
    });

    if (count) count.textContent = visible + (visible === 1 ? ' historia' : ' historias');
    if (empty) empty.hidden = visible !== 0;
    if (searchClear) searchClear.hidden = !state.query;
  }

  if (search) {
    search.addEventListener('input', function () {
      state.query = search.value.trim().toLowerCase();
      applyFilters();
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      search.value = '';
      state.query = '';
      search.focus();
      applyFilters();
    });
  }

  categoryButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state.category = button.getAttribute('data-ms-category') || 'all';
      categoryButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyFilters();
    });
  });

  [gender, age, topic].forEach(function (select) {
    if (!select) return;
    select.addEventListener('change', function () {
      state.gender = gender ? gender.value : '';
      state.age = age ? age.value : '';
      state.topic = topic ? topic.value : '';
      applyFilters();
    });
  });

  if (filtersClear) {
    filtersClear.addEventListener('click', function () {
      state.gender = '';
      state.age = '';
      state.topic = '';
      if (gender) gender.value = '';
      if (age) age.value = '';
      if (topic) topic.value = '';
      applyFilters();
    });
  }

  applyFilters();
})();

(function () {
  var root = document.querySelector('[data-ms-puzzles-catalog]');
  if (!root) return;
  var select = root.querySelector('[data-ms-puzzle-age]');
  var initial = new URL(location.href).searchParams.get('puzzle_age');
  try { initial = initial || sessionStorage.getItem('ms-puzzle-age'); } catch (_) {}
  if (Array.from(select.options).some(function (o) { return o.value === initial; })) select.value = initial;
  function update() {
    try { sessionStorage.setItem('ms-puzzle-age', select.value); } catch (_) {}
    var page = new URL(location.href);
    if (select.value) page.searchParams.set('puzzle_age', select.value); else page.searchParams.delete('puzzle_age');
    history.replaceState(null, '', page);
    root.querySelectorAll('[data-ms-product-card] a').forEach(function (a) {
      var url = new URL(a.href);
      if (select.value) url.searchParams.set('puzzle_age', select.value); else url.searchParams.delete('puzzle_age');
      a.href = url.href;
    });
  }
  select.addEventListener('change', update);
  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-ms-product-card] a') && !select.value) {
      event.preventDefault(); select.focus(); select.reportValidity();
    }
  });
  update();
})();

(function(){var r=document.querySelector('[data-ms-puzzles-catalog]');if(!r)return;var s=r.querySelector('[data-ms-puzzle-age]');var buttons=r.querySelectorAll('[data-pz-age]');function sync(){var n=parseInt(s.value,10);buttons.forEach(function(b){var v=Number(b.dataset.pzAge);b.setAttribute('aria-pressed',String(v=== (n>=8?8:n>=6?6:n>=4?4:n>=2?2:0)));});}buttons.forEach(function(b){b.addEventListener('click',function(){s.value=b.dataset.pzAge;s.dispatchEvent(new Event('change',{bubbles:true}));});});s.addEventListener('change',sync);sync();})();
